// extracted by mini-css-extract-plugin
module.exports = {"section":"DetailSection-module__section--1xRBw","informationProperty":"DetailSection-module__informationProperty--PO4Tf"};